
import type { SxProps } from '@mui/material'

export enum ETableTextType {
    highlighted = 'highlighted',
    price = 'price',
    bold = 'bold',
}



export interface ITableColumns<T extends { id: string }> {
    id: keyof T,
    text: string,
    type?: ETableTextType,
}

export interface ITableProps<T extends { id: string }> {
    columns: ITableColumns<T>[],
    data: T[],
    styles?: SxProps,
    selectedId?: string,
}
